import DefaultProjectDetailView from "src/components/feature/ProjectDetailView/FundApplication";

const FundApplicationDetailView = () => {
  return <DefaultProjectDetailView />;
};

export default FundApplicationDetailView;
